import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import { FONT_SIZE, INK, STATUS } from "../../../../theme/tokens";
import { formatCurrency } from "../../../../utils/utilFunctions";
import { METRIC_LABEL_SX, METRIC_VALUE_SX } from "./gapsMetricsStyles";

type Props = {
	lineKey: "offered" | "committed";
	label: string;
	/** What the line counts, in a few words. */
	hint: string;
	amount: number;
};

/** One of the Pick-up bonuses row's two lines: its label, what it counts, and the amount — green once there is one. */
export const GapsPickupBonusLine: FC<Props> = ({ lineKey, label, hint, amount }) => (
	<Box data-testid={`gaps-metrics-bonus-${lineKey}`} sx={{ display: "flex", alignItems: "baseline", gap: 1 }}>
		<Typography component="span" sx={{ ...METRIC_LABEL_SX, minWidth: 0 }}>
			{label}
		</Typography>
		<Typography component="span" sx={{ flex: 1, minWidth: 0, fontSize: FONT_SIZE.LABEL_SM, color: INK.MUTED, overflowWrap: "anywhere" }}>
			{hint}
		</Typography>
		<Box
			component="span"
			data-testid={`gaps-metrics-bonus-${lineKey}-amount`}
			sx={{ ...METRIC_VALUE_SX, flex: "none", color: amount > 0 ? STATUS.SUCCESS.dark : INK.PRIMARY }}
		>
			{formatCurrency(amount)}
		</Box>
	</Box>
);
